import React from 'react';
import { ReactComponent as FigBuilding05Component } from './FigBuilding05.svg';

const FigBuilding05 = (props) => <FigBuilding05Component {...props} />;

export default FigBuilding05;
